import React from 'react';
import { SectionWrapper } from './shared/SectionWrapper';
import { CTAButton } from './shared/CTAButton';
export function FinalClose() {
  return <SectionWrapper bg="white" className="border-t border-blush" data-id="element-46">
      <div className="max-w-3xl mx-auto" data-id="element-47">
        <h2 className="text-3xl font-serif font-bold text-warm-dark mb-6 text-center" data-id="element-48">
          Cierre final
        </h2>

        <div className="space-y-6 text-lg text-warm-muted mb-10" data-id="element-49">
          <p data-id="element-50">
            Si ya trabajás, no necesitás más motivación. <br data-id="element-51" />
            <strong className="text-rose" data-id="element-52">
              Necesitás técnica que te dé consistencia.
            </strong>
          </p>

          <p data-id="element-53">Porque cuando tu terminación sube:</p>

          <ul className="list-disc list-inside ml-4 space-y-2 font-medium text-warm-dark" data-id="element-54">
            <li data-id="element-55">Tus fotos mejoran</li>
            <li data-id="element-56">Tus clientas confían más</li>
            <li data-id="element-57">Tu agenda se ordena</li>
            <li data-id="element-58">Tus precios suben con seguridad</li>
          </ul>

          <div className="bg-blush p-6 rounded-2xl border border-rose/10 my-8" data-id="element-59">
            <p className="font-bold text-warm-dark mb-4 text-center" data-id="element-60">
              Hoy podés entrar por $29 USD:
            </p>
            <p className="text-center text-sm md:text-base font-medium text-rose" data-id="element-61">
              45 clases · 100% online · acceso de por vida + actualizaciones ·
              certificado avalado · garantía 7 días.
            </p>
          </div>

          <p className="text-sm italic text-center" data-id="element-62">
            Y sí: el precio promocional es por tiempo limitado. <br data-id="element-63" />
            Cuando termine el contador, vuelve a precio regular.
          </p>
        </div>

        <div className="text-center mb-12" data-id="element-64">
          <p className="text-2xl md:text-3xl font-serif font-bold text-warm-dark mb-8 leading-tight" data-id="element-65">
            ¿Cuánto te cuesta hoy tardar de más, retrabajar y no animarte a
            subir precios?
          </p>

          <CTAButton scrollTo="comprar" className="text-lg px-10 py-5 w-full md:w-auto" data-id="element-66">
            SÍ, QUIERO ACCEDER POR $29 USD AHORA
          </CTAButton>
        </div>

        <div className="border-t border-cream pt-8 space-y-4 text-sm text-warm-muted" data-id="element-67">
          <p data-id="element-68">
            <strong className="text-warm-dark" data-id="element-69">P.D.</strong> El acceso es de por
            vida: lo comprás una vez y lo usás cada vez que quieras repasar.
          </p>
          <p data-id="element-70">
            <strong className="text-warm-dark" data-id="element-71">P.D.2</strong> Si tu meta es
            cobrar más, tu técnica tiene que sostenerlo. Empezá por acá.
          </p>
        </div>
      </div>
    </SectionWrapper>;
}